import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Wordmark, FullLogo } from "./Navbar";

export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <footer className="bg-ink text-cream" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <FullLogo className="h-12 w-auto" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">
              A Toronto production company making original films and providing full service production — with the communities that inspire the work.
            </p>
            <p className="mt-5 font-display text-lg font-extrabold tracking-tight text-cream" data-testid="footer-slogan">
              Think <span className="text-orange">Incolour</span>.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-link"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-orange px-6 py-3 text-sm font-semibold text-cream transition-transform hover:scale-[1.03]"
            >
              Start a project <ArrowUpRight size={16} />
            </Link>
          </div>
          <div className="lg:col-span-3">
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-cream/40">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link className="text-cream/80 transition-colors hover:text-orange" to="/original" data-testid="footer-link-original">Original Work</Link></li>
              <li><Link className="text-cream/80 transition-colors hover:text-orange" to="/service" data-testid="footer-link-service">Service Production</Link></li>
              <li><Link className="text-cream/80 transition-colors hover:text-orange" to="/about" data-testid="footer-link-about">About</Link></li>
              <li><Link className="text-cream/80 transition-colors hover:text-orange" to="/journal" data-testid="footer-link-journal">Journal</Link></li>
              <li><Link className="text-cream/80 transition-colors hover:text-orange" to="/contact" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-cream/40">Studio</p>
            <address className="mt-5 space-y-2 text-sm not-italic text-cream/80">
              <p>Toronto &amp; The GTA</p>
              <p><a href="mailto:connect@incolourfilms.ca" className="transition-colors hover:text-orange" data-testid="footer-email-link">connect@incolourfilms.ca</a></p>
            </address>
            <div className="mt-6 flex gap-5 text-sm text-cream/60">
              <a href="https://instagram.com/incolour.media" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-orange" data-testid="footer-social-instagram">Instagram — @incolour.media</a>
              <a href="https://vimeo.com/incolourmedia" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-orange" data-testid="footer-social-vimeo">Vimeo</a>
              <a href="https://pro.imdb.com/company/co0925448/filmography/?ref_=co_knf_t" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-orange" data-testid="footer-social-imdb">IMDb</a>
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-cream/10 pt-6 text-xs font-mono uppercase tracking-[0.2em] text-cream/40 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Incolour Films Inc. — Toronto</p>
          <Link to="/admin/login" className="transition-colors hover:text-orange" data-testid="footer-cms-link">Team CMS Login</Link>
        </div>
      </div>
    </footer>
  );
}
